<template>
  <!-- <div :class="type" class="alert alert-flash text-white py-4" role="alert" v-show="show">
    {{ body }}
  </div> -->
  <div class="alert-flash bg-logo border-t-4 border-logo-dark rounded-b text-white px-4 py-3 shadow-md" role="alert" v-show="show">
    <div class="flex">
      <div class="py-1"><svg class="fill-current h-6 w-6  mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
      <div>
        <p class="font-bold">{{ body }}</p>
        <!-- <p class="text-sm">Make sure you know how these changes affect you.</p> -->
      </div>
    </div>
</div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      body: this.message,
      show: false,
    }
  },


  computed: {
    type: function() {
      return this.body.toLowerCase().indexOf('success') == -1 ? 'bg-red-500' : 'bg-green-500';
    }
  },

  created() {
    if (this.message) {
      // this.flash(this.message);
      if (this.message.indexOf('success') !== -1) {
        this.$toast.success(this.message);
      } else {
        this.$toast.error(this.message);
      }
    }

    window.events.$on('flash', message => {
      this.flash(message);
    });
  },

  methods: {
    flash(message) {
      this.body = message;
      this.show = true;

      this.hide();
    },

    hide() {
      setTimeout(() => {
        this.show = false;
      }, 3000);
    }
  }
}
</script>

<style>
 .alert-flash {
   position: fixed;
   right: 25px;
   bottom: 25px;
 }
</style>
